import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { RootStoreState } from 'src/app/store';
import { IDENTRUST_PHONE_NUMBER } from 'src/app/features/shared/constants';
import { ModalsActions, ModalSize } from 'src/app/features/modals';
import { CancelSigningModalComponent } from 'src/app/features/layout/components';

@Component({
    selector: 'app-certificate-password-limit-exceeded',
    templateUrl: './certificate-password-limit-exceeded.component.html',
    styleUrls: ['./certificate-password-limit-exceeded.component.scss'],
    standalone: false
})
export class CertificatePasswordLimitExceededComponent {

  idenTrustSupportPhone = IDENTRUST_PHONE_NUMBER;

  constructor(private readonly store: Store<RootStoreState.State>) {}

  cancelSigning(): void {
      this.store.dispatch(
        ModalsActions.SetStandaloneModalComponent({
          payload: {
            component: CancelSigningModalComponent,
            componentData: {
              fixedCategoryTypeCode: 'NotaryCommissionIssue'
            }
          },
        })
      );
    }
}
